import PostList from "./PostList";
import React from "react";

import { news } from "../../services/news";

const NewsPage = () => {
    return <PostList fetchPostsFn={news} sectionTitle="Latest News" />;
};

export default NewsPage;
